module.exports = __webpack_public_path__ + "static/half-size-cat-f6c66217bd4a7de95ee1e7f06af48d58.png";